import { client, gql } from './Client';

const fileInfoQuery = gql`
  mutation fileInfo($fileaimsID: Int!) {
    fileInfo(fileaimsID: $fileaimsID)
  }
`;

const fileInfo = (fileaimsID: number) =>
  client.mutate({ mutation: fileInfoQuery, variables: { fileaimsID } });

export { fileInfo };
